<template>
  <div class="page">
    <div class="page__bd">
      <div class="weui-gallery">
        <img
          crossorigin="anonymous"
          :src="cardUrl"
          id="weui-gallery__img"
          class="weui-gallery__img"
        />
        <div class="weui-gallery__tip">长按图片分享</div>
      </div>
    </div>
  </div>
</template>

<script>
const env = process.env.NODE_ENV == 'production' ? 'release' : 'develop';

export default {
  data() {
    return {
      cardUrl: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadCard();
    });
  },
  methods: {
    loadCard() {
      const me = this;
      me.$ajax({
        url: '/api/miniprogram/code/qyq_account_card',
        params: {
          env_version: env
        }
      }).then(function(res){
        me.cardUrl = res.data.cardUrl;
      });
    }
  },
};
</script>

<style scoped>
.weui-gallery {
  background-color: inherit;
  display: block;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.weui-gallery__tip {
  position: absolute;
  bottom: calc(60px + env(safe-area-inset-bottom));
  width: 100%;
  color: var(--weui-FG-1);
  text-align: center;
}
</style>